import { render } from "./PhotoListElement.vue?vue&type=template&id=6a11dbcc"
import script from "./PhotoListElement.vue?vue&type=script&lang=js"
export * from "./PhotoListElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__